import { Badge } from 'flowbite-react';
import React from 'react';

const WaitListedScreen = ({ studentName }: { studentName: string }) => {
	return (
		<div>
			<div className="py-8 flex">
				<div className="border-radius-md w-full p-6 text-start gap-5 flex flex-col">
					<div className="flex justify-start">
						<img src="/assets/waitlist.svg" alt="icon" />
					</div>
					<h2 className="text-3xl text-[#3BAA73] mb-2">Thank you {studentName}!</h2>

					<p className="font-medium mb-4 text-base w-full md:w-60%">
						Thank you for participating in the test. Unfortunately, you did not meet the required criteria for this
						program. <br />
						However, you can retake the test next week. Thank you for your interest.
					</p>
					<p className="text-[16px] text-[#3470E4] font-bold">
						Your registration fee of ₹99 will be refunded within 5-7 business days.
					</p>
				</div>
			</div>
		</div>
	);
};

export default WaitListedScreen;
